module.exports = __webpack_public_path__ + "logo.6beec49d.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/logo.svg
// module id = LtId
// module chunks = 0